<!-- BREADCRUMB -->
<div class="aems-bread-crumb m-b-16">
  <a class="m-r-4" routerLink="/master-data">Master Data</a>
  <span class="m-r-4">/</span>
  <a class="m-r-4" routerLink="/master-data/parts-management"> Parts Management </a>
  <span>/</span>
  <span>
    {{ isEditMode() ? 'Edit Part' : 'Add New' }}
  </span>
</div>

<!-- PAGE TITLE -->
<h3 class="m-b-16">
  {{ isEditMode() ? 'Edit Part' : 'Add New' }}
</h3>

<form [formGroup]="createPartForm" (ngSubmit)="onSubmit()">
  <!-- ERROR BLOCK -->
  @if (formSubmitErrors().length > 0) {
    <div class="error m-b-16">
      <mc-icon class="error-icon" icon="exclamation-octagon" size="20"> </mc-icon>

      <div class="title">Errors</div>

      <ul>
        @for (error of formSubmitErrors(); track $index) {
          <li>{{ error }}</li>
        }
      </ul>
    </div>
  }

  <!-- PART DETAILS -->
  <div class="aems-card m-b-16">
    <p class="mds-content"><strong>Part Details</strong></p>
    <hr class="m-b-12" />

    <app-create-part-details [formGroup]="createPartForm"> </app-create-part-details>
  </div>

  <!-- ZERO COST ACTIVATION WARNING -->
  @if (createPartForm.hasError('zeroCostActivation')) {
    <mc-notification
      class="zero-cost-activation-warning m-b-16"
      appearance="warning"
      fit="small"
      icon="exclamation-triangle"
      body="You are trying to activate a part with 0 cost which is not allowed. Please enter some amount or keep the part inactive">
    </mc-notification>
  }

  <!-- OPERATIONAL SETTINGS -->
  <div class="aems-card m-b-16">
    <p class="mds-content"><strong>Operational Settings</strong></p>
    <hr class="m-b-12" />

    <app-create-parts-operational-settings [formGroup]="createPartForm"> </app-create-parts-operational-settings>
  </div>

  <!-- COMMENTS -->
  <div class="aems-card m-b-16">
    <p class="mds-content"><strong>Comments</strong></p>
    <hr class="m-b-12" />

    <app-create-parts-remarks [formGroup]="createPartForm"> </app-create-parts-remarks>
  </div>

  <!-- BUTTONS -->
  <div class="right m-t-16 action-buttons">
    <!-- CANCEL -->
    <app-button-with-confirmation
      label="Cancel"
      appearance="neutral"
      modalBody="Are you sure you want to cancel part editing? All unsaved changes will be lost permanently."
      modalHeading="Unsaved Changes"
      confirmButtonLabel="Discard Changes"
      cancelButtonLabel="Keep Changes"
      [onConfirm]="onCancel()">
    </app-button-with-confirmation>

    <!-- SUBMIT -->
    <mc-button
      type="submit"
      variant="filled"
      appearance="primary"
      fit="small"
      [loading]="submitLoader()"
      [disabled]="
        isEditMode() ? !createPartForm.dirty || createPartForm.invalid || submitLoader() : createPartForm.invalid || submitLoader()
      ">
      {{ isEditMode() ? 'Save changes' : 'Submit' }}
    </mc-button>
  </div>
</form>
